module.exports = __webpack_public_path__ + "img/login-background.df89cdc0.jpg";